import { Path } from 'history'

export async function initOffice(push: (path: Path) => void): Promise<boolean> {
  const ready = await Office?.onReady()

  if (ready.host !== Office.HostType.Outlook) {
    return false
  }

  const { mailbox } = Office.context

  if (mailbox?.item) {
    // Get the sender and recipient info and send to the app
    let user = mailbox.item.to[0].emailAddress
    let senderEmailAddress = mailbox.item.from.emailAddress
    let senderName = mailbox.item.from.displayName
    let missionCompletedEmail = ''
    const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/

    // Not 100% sold on this approach, but it does work. Someone with a better grasp of async in TS could likely improve this.
    // Main problem is the outlook API's Body.getAsync isn't then-able
    let nextPath = `/init/${user}/${senderEmailAddress}/${senderName}`
    if (
      senderEmailAddress === 'maverick@maverickapp.io' &&
      mailbox.item.subject === 'Completed Mission Notification'
    ) {
      mailbox.item.body.getAsync('text', {}, result => {
        const matches = emailRegex.exec(result.value)
        if (matches && matches.length > 0) {
          // eslint-disable-next-line prefer-destructuring
          missionCompletedEmail = matches[0]
        }
        if (missionCompletedEmail) {
          nextPath += `/${missionCompletedEmail}`
        }
        push(nextPath)
      })
    } else {
      // Thought I could just do this without an else but the async nature of the above requires me to have an else
      push(nextPath)
    }

    // If the selected email changes to a new email, send the new details to the app
    Office.context.mailbox.addHandlerAsync(Office.EventType.ItemChanged, () => {
      if (mailbox?.item) {
        user = mailbox.item.to[0].emailAddress
        senderEmailAddress = mailbox.item.from.emailAddress
        senderName = mailbox.item.from.displayName

        // see comment on line 20
        if (
          senderEmailAddress === 'maverick@maverickapp.io' &&
          mailbox.item.subject === 'Completed Mission Notification'
        ) {
          mailbox.item.body.getAsync('text', {}, result => {
            const regexMatch = emailRegex.exec(result.value)
            missionCompletedEmail = regexMatch ? regexMatch[0] : ''
            push(`/init/${user}/${senderEmailAddress}/${senderName}/${missionCompletedEmail}`)
          })
        } else {
          push(`/init/${user}/${senderEmailAddress}/${senderName}/${missionCompletedEmail}`)
        }
      }
    })

    return true
  }

  return false
}

export function getEnvironment(): 'outlook-web' | 'outlook-desktop' | 'chrome' {
  let windowName: { hostInfo: string }
  if (
    window &&
    window.location &&
    window.location.ancestorOrigins &&
    window.location.ancestorOrigins[0] &&
    window.location.ancestorOrigins[0].includes('mail.google.com')
  ) {
    return 'chrome'
  }
  // Running in a full screen window, assume we do not have the office context
  const fullscreenPages = [
    '/settings/templates',
    '/settings/add-to-dne',
    '/settings/billing',
    '/settings/prospect-criteria',
    'settings/reports',
    '/prospects/engagement/',
    '/settings/signatures',
  ]
  if (
    window &&
    window.location &&
    window.location.search &&
    window.location.search.includes('fullscreen')
  ) {
    return 'chrome'
  }
  if (
    window &&
    window.location &&
    window.location.pathname &&
    fullscreenPages.includes(window.location.pathname)
  ) {
    return 'chrome'
  }
  try {
    windowName = JSON.parse(window.name)

    if (windowName.hostInfo.toLowerCase().includes('outlook')) {
      return 'outlook-web'
    }
  } catch (e) {
    // If not Outlook web or chrome, assume client is outlook desktop
    return 'outlook-desktop'
  }
  // If not Outlook web or chrome, assume client is outlook desktop
  return 'outlook-desktop'
}

export function loadOffice(cb: () => Promise<void>): void {
  // // Inject office.js into the page
  const officeScript = document.createElement('script')
  officeScript.setAttribute('src', 'https://appsforoffice.microsoft.com/lib/1/hosted/office.js')
  officeScript.setAttribute('type', 'text/javascript')
  document.head.appendChild(officeScript)

  // TODO: do this correctly, where the app waits until office.js is loaded then calls the cb
  setTimeout(() => {
    cb()
  }, 500)
}
